import { TooltipProvider } from "@screener/uikit/components/tooltip";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app";
import { initAnalytics } from "./lib/analytics";
import {
  captureConfirmToken,
  captureResetToken,
  captureSignupToken,
  watchSignupHash,
} from "./lib/signup-route";
import "./styles.css";

// Токен ссылки-приглашения уходит из адреса ДО аналитики: PostHog читает адрес
// при инициализации и не должен его увидеть (stage9-signup-invites, Д9).
captureSignupToken();
// То же для ссылки подтверждения почты из письма (`#/confirm/{token}`).
captureConfirmToken();
// И для ссылки сброса пароля (`#/reset/{token}`).
captureResetToken();
// Ссылку можно вставить и в открытую вкладку (`hashchange`): перехватчик на
// стадии погружения забирает токен раньше всех слушателей адреса.
watchSignupHash();

// До рендера, чтобы ошибки первого рендера уже ловились (§103, design.md Д4).
initAnalytics();

const root = document.getElementById("root");
if (!root) {
  throw new Error("не найден корневой элемент #root");
}

createRoot(root).render(
  <StrictMode>
    <TooltipProvider>
      <App />
    </TooltipProvider>
  </StrictMode>,
);
